import { Link } from 'react-router-dom'
import Debaters from './Debaters'
import { getTimeZoneDate, readableDate } from '../common/set_date'



function DashTrendingDebates({debaters}) {


  const date = readableDate(debaters?.date_created)

  function hasDatePassed(dateStr) {
    if (!dateStr) return null;

    try {

        const cleanDateStr = dateStr
            .replace(' at ', ' ')
            .replace(/\(UTC[+-]\d{2}:\d{2}\)/, '') // Remove UTC offset notation
            .trim();

        const targetDate = new Date(cleanDateStr);

        // Check if the date is valid
        if (isNaN(targetDate.getTime())) {
            // throw new Error('Invalid date format');
        }

        const currentDate = new Date();
        return currentDate > targetDate;
    } catch (error) {
        // console.error('Error parsing date:', error.message);
        return null;
    }

  }

  function getDebateState(){
    const tz = getTimeZoneDate(debaters?.start_at)


    if(debaters?.finished || !tz){
      return <p className='mt-4 text-red-600'>Debate Over</p>
    }else if(!debaters?.finished && debaters?.has_started){
      return <p className='mt-4 text-green-600'>Debate Ongoing</p>
    }else{
      return <div className='mt-4'>
                {hasDatePassed(tz) ?
                  <p className='text-red-600'>Debate Over</p>
                :
                <>
                <p>Debate Date: {getTimeZoneDate(debaters?.start_at)}</p>
                <p className='mt-4'>Duration: {debaters?.duration}</p>
                </>
                }

            </div>
    }
  }

 return (

    <div className='flex flex-col sm:justify-center py-5 px-2.5 sm:px-4'>
    <p className='text-[10px] mt-2'>{date}</p>
            <div className='flex justify-around flex-col sm:px-4 mt-5'>
            <h3 className='text-2xl font-bold'>{debaters?.topic}</h3>
              <p className='italic font-light my-1'><i>Created by:</i> {debaters?.author?.username}</p>
              {getDebateState()}
            </div>

        <div className='flex justify-between sm:justify-center my-5'>
        <Debaters
        name={debaters?.supporting[0]?.name}
        profileID={debaters?.supporting[0]?.id}
        userImg={debaters?.supporting[0]?.profileImage}
        stance="Supporting"
         />

        <div className='flex justify-center items-center mx-3 md:mx-8  md:h-[270px]' >
        <h3 className='text-[18px] sm:text-2xl font-bold'>Vs</h3>
        </div>

        <Debaters
        name={debaters?.opposing[0]?.name}
        profileID={debaters?.opposing[0]?.id}
        userImg={debaters?.opposing[0]?.profileImage}
        stance="Opposing"
         />
        </div>



  <Link to={`/debates/${debaters?.debate_id}`}>
  <div className='flex justify-center md:pr-5'>
  <button className='w-full sm:w-3/4 px-4 sm:px-10 py-2 bg-[#474B7D] hover:bg-[#444770] rounded-md
  text-sm sm:text-[16px]'>Enter Debate Room</button>
  </div>
  </Link>


    </div>






  )
}

export default DashTrendingDebates
